module.exports = __webpack_public_path__ + "static/media/cent3.ef7144ea.jpg";